
<template>
  <div>

    <div v-if="this.loadingFormSubmit == true" class="loader">Loading...</div>

    <div v-if="this.loadingFormSubmit == false" id="AddPropertyForm" class="form-container">
       <el-card class="form-card">
          <el-form :model="form" ref="form" :rules="rules">
              <el-form-item label="Image">
                <PictureUpload
                  v-on:picture-id="handlePictureid($event)"
                  v-on:removePictureId="RemovePictureIdLocally($event)"
                />
              </el-form-item>

              <el-form-item label="Property Name" prop="propertyname">
                <el-input
                  class="tst-property-name"
                  v-model="form.propertyname"
                  :rules="inputRules"
                  placeholder="ex: Brooklyn Heights Apartment Complex"
                  required
                ></el-input>
              </el-form-item>

              <el-form-item label="Search for address:">
                <br />
                <vue-google-autocomplete
                  ref="googleAddress"
                  id="map"
                  class="google-map-field"
                  placeholder="Please type your address"
                  v-on:placechanged="setAddressData"
                ></vue-google-autocomplete>
              </el-form-item>

              <el-form-item label="Address">
                <el-input
                  class="tst-property-address"
                  v-model="form.address"
                  :rules="inputRules"
                  placeholder="ex: 21 Green Street"
                  required
                ></el-input>
              </el-form-item>
              <el-form-item label="City">
                <el-input
                  class="tst-property-city"
                  v-model="form.city"
                  :rules="inputRules"
                  placeholder="ex: New York City"
                  required
                ></el-input>
              </el-form-item>

              <el-form-item label="State">
                <el-input class="tst-property-state"
                  v-model="form.state" :rules="inputRules" placeholder="ex: New York" required></el-input>
              </el-form-item>

              <el-form-item label="Zipcode">
                <el-input class="tst-property-zip"
                  v-model="form.zip" :rules="inputRules" placeholder="ex: 11234" required></el-input>
              </el-form-item>

              <el-form-item label="Country">
                <el-input class="tst-property-country"
                  v-model="form.country" :rules="inputRules" placeholder="ex: USA" required></el-input>
              </el-form-item>

              <div class="buttons">
                <el-button class="tst-confirm-create-property-button"
                  type="primary" icon="el-icon-check" @click="SubmitForm()">Add Property</el-button>
                <br />
                <el-button class="tst-cancel-create-button"
                  type="info" icon="el-icon-delete" @click="CloseForm()" >Cancel</el-button>
              </div>
            </el-form>
         </el-card> 
     </div>
  </div>	
</template>

<script>
import VueGoogleAutocomplete from "vue-google-autocomplete";
import PictureUpload from "@/components/utilities/PictureUploadSingle.vue";
import EventService from "@/services/EventService.js";

export default {
   
  components:{
      VueGoogleAutocomplete,
      PictureUpload
  },

  data() {
    return {
      fabActions: [
        {
          name: "test",
          icon: "cached"
        }
      ],
      properties: [],

      googleAddress: "",
      dialogVisible: false,
      form: {
        propertyname: null,
        address: "",
        city: "",
        state: "",
        zip: "",
        country: "",
        organizationtypes: [],
        pictureid: [],
        timezoneoffset: ""
      },
      inputRules: [v => (v && v.length != 0) || "This field is required"],
         rules: {
          propertyname: [
            { required: true, message: 'Please input Property name', trigger: 'blur' },
          ],
       },
       invalid: Boolean,
       loadingFormSubmit: false
    };
  },

 methods: {   


    SubmitForm() {

        this.$refs["form"].validate((valid) => {
          if (valid) {
          } else {
            this.invalid = true;
            return false;
          }
        });
        if(this.invalid == true){
          this.invalid = false;
          return;
        }

      this.loadingFormSubmit = true;

      this.form.organizationtypes = Object.values(this.form.organizationtypes);

      //get the users timezone and submit it with the form
      var offset = new Date().getTimezoneOffset();
      var o = Math.abs(offset);
      this.form.timezoneoffset = (offset < 0 ? "+" : "-") + ("00" + Math.floor(o / 60)).slice(-2) + ":" + ("00" + (o % 60)).slice(-2);

      EventService.addProperty(this.form)
        .then(response => {

          this.$root.$emit("property-added", response.data);
          
          this.CloseForm();
        })
        .then(response => {
          this.$store.dispatch("addNotification", {
            type: "success",
            Message: "Property added"
          });
        })
        .catch(error => {
           console.log(error);
           this.CloseForm();
        });
     },

    CloseForm(){
      this.$root.$emit("close-add-property");
    },

    handlePictureid($event) {
      //for (const object of $event) {
      this.form.pictureid.push($event.pictureid);
      //}
    },
    RemovePictureIdLocally(img) {
      this.$delete(this.form.pictureid, this.form.pictureid.indexOf(img));
    },
    updatePropertyLocally($event) {
      this.$set(this.properties, this.properties.indexOf($event[1]), $event[0]);
      this.toggleeditpropertyform();
    },

    setAddressData: function(addressData, placeResultData, id) {
      const addressComponents = placeResultData.address_components;
      // const streetNumberComponent = addressComponents.find(({ types }) =>
      //   types.includes("street_number")
      // );
      // const streetNameComponent = addressComponents.find(({ types }) =>
      //   types.includes("route")
      // );
      // const addressComponent = streetNumberComponent
      //   ? streetNumberComponent.long_name + ""
      //   : "" + streetNameComponent
      //   ? streetNameComponent.long_name
      //   : "";
      // const zipComponent = addressComponents.find(({ types }) =>
      //   types.includes("postal_code")
      // );
      const cityComponent = addressComponents.find(
        ({ types }) =>
          types.includes("administrative_area_level_3") ||
          types.includes("sublocality_level_1")
      );
      // const stateComponent = addressComponents.find(({ types }) =>
      //   types.includes("administrative_area_level_1")
      // );
      // const countryComponent = addressComponents.find(({ types }) =>
      //   types.includes("country")
      // );

      if(addressData.street_number != undefined){
      this.form.address = addressData.street_number + " " + addressData.route;
      } else {
      this.form.address = addressData.route;
      }
      this.form.zip = addressData.postal_code;
      this.form.city = cityComponent ? cityComponent.long_name : "";
      this.form.state = addressData.administrative_area_level_1;
      this.form.country = addressData.country;
    }
        }  

}
</script>

<style>

</style>